import { render, staticRenderFns } from "./CGroup.vue?vue&type=template&id=17a7e285&"
import script from "./CGroup.vue?vue&type=script&lang=js&"
export * from "./CGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports